import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-calorie-friend',
  template: `
    <router-outlet></router-outlet>
    <div class="bottom-padding"><br /><br /><br /><br /></div>
  `,
  styles: [
    `
      .bottom-padding {
        display: none;
      }

      @media screen and (max-width: 531px) {
        .bottom-padding {
          display: block;
        }
      }
    `,
  ],
})
export class CalorieFriendComponent implements OnInit {
  constructor() {}
  // convert window inner height to lvh
  // convertWindowInnerHeightToLvh() {
  //   const vh = window.innerHeight * 0.01;
  //   (document.getElementsByClassName('scrollable-container')[0] as any).style.height = window.innerHeight - 75 + 'px';
  // }
  ngOnInit(): void {
    // set resize event
    // this.convertWindowInnerHeightToLvh();
  }
  // set resize using hostlistener
  @HostListener('window:resize', ['$event'])
  onResize(event) {
   // this.convertWindowInnerHeightToLvh();
  }


}
